export const setExtrinsicsList = extrinsics => dispatch => {
    dispatch({
        type:   'SET_EXTRINSICS_LIST',
        payload:    extrinsics
    })
}
